<template>
  <div class="cardlist">
    <div class="cardlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px;"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            icon="el-icon-search"
            plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            plain
            class="el-icon-plus"
            @click="dialogFormVisible = true"
          >新增</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <!-- 封装的 i-table组件-->
        <!-- <div class="table-page">
                <i-table :list="list.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)"
                    @handleSelectionChange="handleSelectionChange"
                    :options="options"
                    :columns="columns"
                    :operates="operates"
                >
                </i-table>
        </div>-->
        <el-table
          :data="list"
          style="width: 100%"
         :row-style="tableRowStyle"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column label="设备编号" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
                label="设备类型"
                align="center"
                :show-overflow-tooltip="true"
                >
                <template slot-scope="scope">
                    <span style="margin-left: 10px" v-if="scope.row.deviceType===8">门禁卡</span>
                </template>
          </el-table-column>-->
          <el-table-column label="设备名称" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备描述" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.remark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span
                style="margin-left: 10px;color:orange;"
                v-if="scope.row.oldmanName==null || scope.row.oldmanName==''"
              >暂未绑定</span>
              <span style="margin-left: 10px" v-else>{{ scope.row.oldmanName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否开关门" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="margin-left: 10px;color:red;" v-if="scope.row.door==0">关</span>
              <span style="margin-left: 10px;color:green;" v-else>开</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                plain
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
              <el-button
                type="info"
                size="mini"
                plain
                @click="gotoPush(scope.$index,scope.row)"
              >出入记录</el-button>
              <el-button
                type="success"
                size="mini"
                v-if="scope.row.status"
                plain
                @click="handleBangdi(scope.$index, scope.row)"
              >绑定</el-button>
              <el-button
                type="primary"
                size="mini"
                v-if="!scope.row.status"
                plain
                @click="handleJiebang(scope.$index, scope.row)"
              >解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="accessxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="xzdate">
            <el-input v-model.trim="form.xzdate" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="xzname">
            <el-input v-model.trim="form.xzname" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="xzsec">
            <el-input v-model.trim="form.xzsec" type="textarea" :rows="3" placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出修改-->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="accessedit"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="editdate">
            <el-input disabled v-model.trim="formedit.editdate" auto-complete="off" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="editname">
            <el-input v-model.trim="formedit.editname" auto-complete="off" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="editsec">
            <el-input
              v-model.trim="formedit.editsec"
              auto-complete="off"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitFormEdit('formedit')" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出填写老人姓名-->
      <el-dialog
        title="绑定门禁卡"
        :visible.sync="dialogFormBangdi"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="bangdilocation"
        @close="closeBangdi"
      >
        <el-form ref="formBangdi" :model="formBangdi" :rules="rules">
          <el-form-item label="设备编号 :" :label-width="formLabelWidth">
            <span class="height40">{{ formBangdi.bindDeviceNo }}</span>
          </el-form-item>
          <!-- by guo 2019-12-06-15:38添加 -->
          <el-form-item label="绑定类型 :" :label-width="formLabelWidth" prop="roleId">
            <el-select
              v-model="formBangdi.roleId"
              placeholder="请选择门禁卡角色"
              filterable
              @change="changeRadioBindType"
            >
              <el-option
                v-for="(item,index) in roleList"
                :key="index"
                :label="item.roleName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 老人 -->
          <el-form-item
            label="老人姓名 :"
            ref="oldmanName"
            :label-width="formLabelWidth"
            prop="oldmanName"
            v-if="bindType=='oldman'"
          >
            <el-select
              v-model="formBangdi.oldmanName"
              placeholder="请选择老人"
              filterable
              @change="currentSel"
            >
              <el-option
                v-for="(item,index) in oldmanNameIdList"
                :key="index"
                :label="item.oldName"
                :value="item.oldName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="老人身份证 :"
            :label-width="formLabelWidth"
            v-if="bindType=='oldman'"
            prop="oldIdCard"
          >
            <span class="height40" v-if="formBangdi.oldIdCard">{{ formBangdi.oldIdCard }}</span>
            <span class="height40" v-else>暂无数据</span>
          </el-form-item>

          <!-- 员工 -->
          <el-form-item
            label="员工姓名 :"
            ref="oldmanName"
            :label-width="formLabelWidth"
            prop="oldmanName"
            v-if="bindType=='emp'"
          >
            <el-select
              v-model="formBangdi.oldmanName"
              placeholder="请选择员工"
              filterable
              @change="currentSelTwo"
            >
              <el-option
                v-for="(item,index) in oldmanNameIdListTwo"
                :key="index"
                :label="item.oldName"
                :value="item.oldName"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="员工身份证 :" :label-width="formLabelWidth" v-if="bindType=='emp'">
                    <span class="height40" v-if="formBangdi.oldIdCard">{{ formBangdi.oldIdCard }}</span>
                    <span class="height40" v-else>暂无数据</span>
          </el-form-item>-->

          <!-- 其他角色 -->
          <el-form-item
            label="角色姓名 :"
            ref="otherName"
            :label-width="formLabelWidth"
            prop="otherName"
            v-if="bindType=='other'"
          >
            <el-input
              v-model.trim="formBangdi.otherName"
              auto-complete="off"
              placeholder="请输入角色姓名"
              style="width:220px;"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelBangdi">取 消</el-button>
          <el-button type="primary" @click="submitFormBangdi('formBangdi')">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      bindType: "", //门禁卡绑定的角色类型   oldman----老人     emp----员工    other----其他
      roleList: [], //门禁卡角色的集合
      addLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的门禁卡结果集合 分页数据
      allList: [], //返回所有的门禁卡结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      oldmanNameIdList: [], //老人姓名和Id和身份证（用于下拉菜单展示老人以及绑定的时候 删除老人操作）
      oldmanIdNameUnshift: [], //用于解绑时 添加老人操作
      oldmanNameIdListTwo: [], //员工姓名和Id和身份证（用于下拉菜单展示员工以及绑定的时候 删除员工操作）
      oldmanIdNameUnshiftTwo: [], //用于解绑时 添加员工操作
      oldIdCard: [], //老人身份证
      oldmanList: [], //老人所有信息列表
      oldmanListTwo: [], //员工所有信息列表
      formInline: {
        inputdeviceno: ""
      },
      // options: {
      //     stripe: true, // 是否为斑马纹 table
      //     //loading: true, // 是否添加表格loading加载动画
      //     highlightCurrentRow: true, // 是否支持当前行高亮显示
      //     mutiSelect: false, // 是否支持列表项选中功能
      // }, // table 的参数
      // columns: [
      // {
      //     prop: 'deviceNo',
      //     label: '设备编号',
      //     align: 'center',
      // },
      // {
      //     prop: 'deviceType',
      //     label: '设备类型',
      //     align: 'center',
      //     formatter: (row, column, cellValue) => {
      //     return row.deviceType===8 ? `<span style="white-space: nowrap;color: dodgerblue;">门禁卡</span>` : " "
      //     }
      // },
      // {
      //     prop: 'remark',
      //     label: '设备描述',
      //     align: 'center',
      // },
      // {
      //     prop: 'deviceName',
      //     label: '设备名称',
      //     align: 'center',
      // },
      // // //  {
      // // //   prop: 'state',
      // // //   label: '设备描述',
      // // //   align: 'center',
      // // //   render: (h, params) => {
      // // //    return h('el-tag', {
      // // //    props: {type: params.row.state === 0 ? 'success' : params.row.state === 1 ? 'info' : 'danger'} // 组件的props
      // // //    }, params.row.state === 0 ? '上架' : params.row.state === 1 ? '下架' : '审核中')
      // // //   }
      // //  },

      // ], // 需要展示的列
      // operates: {
      // width: 300,
      // fixed: 'right',
      // offset:20,
      // list: [
      //     {
      //         id:'1',
      //         label: '修改',
      //         type: 'warning',
      //         show: true,
      //         icon: 'el-icon-edit',
      //         plain: false,
      //         disabled: false,
      //         method: (index, row) => {
      //             this.handleEdit(index, row)
      //     }
      //     },
      //     {
      //         id:'2',
      //         label: '删除',
      //         type: 'danger',
      //         icon: 'el-icon-delete',
      //         show: true,
      //         plain: false,
      //         disabled: false,
      //         method: (index, row) => {
      //             this.handleDelete(index, row)
      //         }
      //     },
      //     {
      //         id:'3',
      //         label: '绑定',
      //         type: 'success',
      //         icon: 'el-icon-goods',
      //         show: true,
      //         plain: false,
      //         disabled: false,
      //         method: (index, row) => {
      //             this.handleBangdi(index, row)
      //         }
      //     },
      // ]
      // },// 列操作按钮

      //绑定老人
      dialogFormBangdi: false,
      formBangdi: {
        oldmanName: "", //老人姓名
        oldmanId: "", //老人id
        deviceId: "", //设备id
        oldIdCard: "", //老人身份证编号
        bindDeviceNo: "", //绑定模态框弹出的设备编号
        otherName: ""
      },

      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: ""
        // xzaddress:'',
      },
      formLabelWidth: "120px",

      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: ""
        // editaddress:'',
      },

      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{min: 1, max:30, message: '长度在 1到 30 个字符'},
          //{ pattern: /^[A-Za-z0-9]+$/, message: '请输入由数字和字母组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母或_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        xzsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" }
        ],
        xzname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }
        ],

        // 修改正则验证匹配规则
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 1, max:30,  message: '长度在 1到 30 个字符', },
          //{ pattern: /^[A-Za-z0-9]+$/, message: '请输入由数字和字母组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" } //by  guo 2020-4-26-18:12修改
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],

        oldmanName: [
          {
            required: true, //是否必填
            message: "请选择", //规则
            trigger: "change" //何事件触发
          }
        ],
        roleId: [
          {
            required: true, //是否必填
            message: "请选择门禁卡角色", //规则
            trigger: "change" //何事件触发
          }
        ],
        oldmanId: [],
        otherName: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          { min: 1, max: 15, message: "长度在 1到 15 个字符" }
        ],
        oldIdCard: [],
      },
      fileFlag:false,
    };
  },
  methods: {
    //选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },
    //点击查寻
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      console.log("回车搜索", keyCode, e);
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
     // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    //跳转到出入记录页
    gotoPush(index, row) {
      if (row.bind == false) {
        this.$message({
          type: "error",
          message: "该设备还未绑定,请先绑定后再进行操作!"
        });
      } else {
        this.formedit = Object.assign({}, row); //深拷贝数据
        console.log(this.formedit.id);
        var id = this.formedit.id;
        this.$router.push({ path: "/exitrecord", query: { labelId: id } }); //编程式导航跳转  query传参
      }
    },

    //弹出框下拉菜单change事件  选择老人
    currentSel(selVal) {
      this.formBangdi.oldmanName = selVal;
      this.oldmanNameIdList.forEach((item, index) => {
        if (this.formBangdi.oldmanName == item.oldName) {
          this.formBangdi.oldIdCard = item.oldIdCard;
        }
        console.log(item.oldName);
        console.log(item.oldIdCard);
      });
    },

    //弹出框下拉菜单change事件  选择员工
    currentSelTwo(selVal) {
      this.formBangdi.oldmanName = selVal;
    },

    //关闭绑定dialog的回调
    closeBangdi() {
      this.$nextTick(() => {
        if (this.$refs.formBangdi != undefined) {
          this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.bindType = "";
    },

    //绑定 取消的dialog
    cancelBangdi() {
      this.dialogFormBangdi = false;
      this.$nextTick(() => {
        if (this.$refs.formBangdi != undefined) {
          this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.bindType = "";
    },

    //绑定,弹出模态框填写老人信息
    handleBangdi(index, row) {
      console.log(index, row);
      this.$nextTick(() => {
        if (this.$refs.formBangdi != undefined) {
          this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
        }
      });
      this.bindType = "";
      this.queryAccessRoleList(); //查询门禁卡角色列表
      this.dialogFormBangdi = true;
      this.formBangdi = Object.assign({}, row); //深拷贝数据
      console.log(this.formBangdi.id, this.allList);
      this.formBangdi.deviceId = this.formBangdi.id;
      this.formBangdi.bindDeviceNo = this.formBangdi.deviceNo;
      this.formBangdi.roleId = null;
      //点击绑定时弹出dialog,然后循环判断select菜单已经绑定的老人，如果已经绑定就将其移除
      this.allList.forEach((item, index) => {
        console.log(item, index);
        this.oldmanNameIdList.forEach((item2, index2) => {
          // console.log(item2,index2);
          //通过老人的oldmanId和已经绑定的状态 bind  true为绑定  fasle为解绑   来进行判断
          if (item2.oldmanId == item.oldmanId && item.bind == true) {
            this.oldmanNameIdList.splice(index2, 1); //删除数组中对应的值
          }
        });
      });
      console.log(this.oldmanNameIdList);
      //点击绑定时弹出dialog,然后循环判断select菜单已经绑定的员工，如果已经绑定就将其移除
      this.allList.forEach((item, index) => {
        console.log(item, index);
        this.oldmanNameIdListTwo.forEach((item2, index2) => {
          // console.log(item2,index2);
          //通过员工的oldmanId和已经绑定的状态 bind  true为绑定  fasle为解绑   来进行判断
          if (item2.oldmanId == item.oldmanId && item.bind == true) {
            this.oldmanNameIdListTwo.splice(index2, 1); //删除数组中对应的值
          }
        });
      });
      console.log(this.oldmanNameIdListTwo);
    },

    //解绑
    handleJiebang($index, row) {
      var list = []; //声明一个空数组，用于存储解绑的老人信息

      if (row.roleCode == "oldman") {
        //循环另一个集合  判断取到对应的老人信息
        this.oldmanIdNameUnshift.forEach((item, index) => {
          console.log(item, index);
          console.log(row.oldmanId);
          if (row.oldmanId == item.oldmanId) {
            var obj = {};
            obj.oldName = item.oldName;
            obj.oldmanId = item.oldmanId;
            obj.oldIdCard = item.oldIdCard;
            list.push(obj);
          }
        });
      } else if (row.roleCode == "emp") {
        //循环另一个集合  判断取到对应的员工信息
        this.oldmanIdNameUnshiftTwo.forEach((item, index) => {
          console.log(item, index);
          console.log(row.oldmanId);
          if (row.oldmanId == item.oldmanId) {
            var obj = {};
            obj.oldName = item.oldName;
            obj.oldmanId = item.oldmanId;
            obj.oldIdCard = item.oldIdCard;
            list.push(obj);
          }
        });
      }

      console.log(list);
      console.log(row);
      console.log(this.oldmanNameIdList, this.oldmanNameIdListTwo);
      this.$confirm("此操作将解除绑定, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false
      })
        .then(() => {
          this.formBangdi = Object.assign({}, row); //深拷贝数据
          let deviceId = this.formBangdi.id;
          this.$postJson(
            "dmc/rfidLabel/breakDmcRfidLabelOldmanByDeviceId/" + deviceId
          ).then(res => {
            console.log(this.oldmanNameIdList, this.oldmanNameIdListTwo);
            // //通过循环判断解绑的老人oldmanId ,将解绑的老人信息 再重新添加进oldmanNameIdList的集合中  使其在select下拉菜单老人列表中显示出来
            this.allList.forEach((item, index) => {
              //console.log(item,index);
              console.log(item.oldmanId == row.oldmanId);
              if (item.oldmanId == row.oldmanId) {
                // this.oldmanNameIdList.unshift(list[0])
                //by guo 2019-12-07-18:03修改
                if (item.roleCode == "oldman") {
                  //老人
                  this.oldmanNameIdList.unshift(list[0]);
                } else if (item.roleCode == "emp") {
                  //员工
                  this.oldmanNameIdListTwo.unshift(list[0]);
                }
              }
            });
            //数组中的对象去重，因为在老人列表修改
            let obj = {};
            this.oldmanNameIdList = this.oldmanNameIdList.reduce(
              (cur, next) => {
                obj[next.oldName]
                  ? ""
                  : (obj[next.oldName] = true && cur.push(next));
                return cur;
              },
              []
            ); //设置cur默认类型为数组，并且初始值为空的数组
            console.log(this.oldmanNameIdList);

            //数组中的对象去重，因为在老人列表修改
            let obj2 = {};
            this.oldmanNameIdListTwo = this.oldmanNameIdListTwo.reduce(
              (cur, next) => {
                obj2[next.oldName]
                  ? ""
                  : (obj2[next.oldName] = true && cur.push(next));
                return cur;
              },
              []
            ); //设置cur默认类型为数组，并且初始值为空的数组
            console.log(this.oldmanNameIdListTwo);
            //console.log(res);
            this.getTableData();
            this.getALLDate();
            if (res.code == 500) {
              setTimeout(() => {
                this.$message({
                  message: "门禁卡未绑定",
                  type: "error"
                });
              }, 300);
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success"
                });
              }, 300);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消解绑"
          });
        });
    },

    //绑定类型 by guo 2019-12-06-15:48添加
    changeRadioBindType(val) {
      console.log(val);
      this.roleList.forEach(item => {
        if (val == item.id) {
          this.bindType = item.roleCode; //门禁卡绑定的角色类型
          console.log(this.bindType);
        }
      });
      if (
        this.bindType == "oldman" ||
        this.bindType == "emp" ||
        this.bindType == "other"
      ) {
        this.$refs.formBangdi.clearValidate(); //移除校验结果并重置字段值
      }
      this.formBangdi.oldmanName = "";
      this.formBangdi.oldIdCard = "";
    },

    //绑定门禁读卡器提交数据
    submitFormBangdi(datainfo) {
      if (this.bindType == "oldman") {
        //老人
        //循环判断 取出对应的oldmanId和oldmanName
        this.oldmanNameIdList.forEach((item, index) => {
          if (this.formBangdi.oldmanName == item.oldName) {
            this.formBangdi.oldmanId = item.oldmanId;
          }
          console.log(item.oldName);
          console.log(item.oldmanId);
        });
      } else if (this.bindType == "emp") {
        //员工
        //循环判断 取出对应的oldmanId和oldmanName
        this.oldmanNameIdListTwo.forEach((item, index) => {
          if (this.formBangdi.oldmanName == item.oldName) {
            this.formBangdi.oldmanId = item.oldmanId;
          }
          console.log(item.oldName);
          console.log(item.oldmanId);
        });
      }

      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = new Object();
          param.deviceId = this.formBangdi.deviceId;
          //判断一下  当绑定的角色类型为 其他 提交的数据源为otherName  否则就为oldmanName
          if (this.bindType == "other") {
            param.oldmanName = this.formBangdi.otherName;
          } else {
            param.oldmanName = this.formBangdi.oldmanName;
          }
          param.roleId = this.formBangdi.roleId;
          //by guo 2019-11-09 修改 当绑定角色为老人和员工的时候就需要传oldmanId   绑定角色为其他 时是不需要传oldmanId  因此需要判断一下
          if (
            this.formBangdi.oldmanId != null &&
            this.formBangdi.oldmanId != "" &&
            this.formBangdi.oldmanId != undefined
          ) {
            param.oldmanId = this.formBangdi.oldmanId;
          }
          console.log(param);
          this.$postJson("dmc/rfidLabel/bindDmcRfidLabelOldman", param).then(
            res => {
              console.log(res);
              this.dialogFormBangdi = false;
              if (res.code == "10061011") {
                setTimeout(() => {
                  this.$message({
                    message: "门禁卡已经绑定过",
                    type: "error"
                  });
                }, 300);
              } else {
                if (this.bindType == "oldman") {
                  //老人
                  //绑定成功后 循环判断 将对应的老人从数组中删除  老人姓名从select菜单中删除
                  this.oldmanNameIdList.forEach((item, index) => {
                    console.log(item, index);
                    if (this.formBangdi.oldmanName == item.oldName) {
                      this.oldmanNameIdList.splice(index, 1);
                    }
                  });
                } else if (this.bindType == "emp") {
                  //员工
                  //循环判断 取出对应的oldmanId和oldmanName
                  this.oldmanNameIdListTwo.forEach((item, index) => {
                    if (this.formBangdi.oldmanName == item.oldName) {
                      this.formBangdi.oldmanId = item.oldmanId;
                    }
                    console.log(item.oldName);
                    console.log(item.oldmanId);
                  });
                }
                console.log(this.formBangdi.oldmanName);
                this.$refs.formBangdi.resetFields(); //移除校验结果并重置字段值
                this.getTableData();
                this.getALLDate();
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
              }
            }
          );
        }
      });
    },
    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      //this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate(valid => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/bodySensor/edit", param)
            .then(res => {
              console.log(res);
              this.editLoading = false;
              this.dialogFormEdit = false; //关闭修改弹窗
              this.$bus.$emit("submitFormEditchange_accesslist"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("修改成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
            })
            .catch(res => {
              this.$message({
                type: "error",
                message:  res.message
              });
            });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      if (row.bind == false) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false
        })
          .then(() => {
            console.log(index, row);
            let id = row.id;
            console.log(id);
             this.$postJson(`dmc/propertyManagement/untie`,{deviceIds:[id]}).then(res => { //旧 dmc/rfidLabel/deleteById/
             if(res.code ==200){
                this.$bus.$emit("handleDeletechange_accesslist"); //发送一个change事件
              console.log(res);
              this.$message({
                type: "success",
                message: res.message
              });
             }else{
               this.$message({
                type: "error",
                message: res.message
              });
             }
             
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!"
        });
      }
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson("dmc/propertyManagement/bindDeviceMerchant", param)
            .then(res => {
              //旧：dmc/rfidLabel/add
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              this.$bus.$emit("submitFormchange_accesslist"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success"
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error"
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },

    //获取分页的门禁卡数据  只获取了pageSize个数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno
      };
      console.log(param);
      this.loading = true;
      this.$postJson(
        "dmc/rfidLabel/queryGroupRfidLabelListWithPage",
        param
      ).then(res => {
        console.log(res);
        //判断是否有数据
        if (res.result.list.length != 0) {
          this.pageSize = res.result.pageSize;
          this.currentPage = res.result.pageNum;
          this.totalDataNumber = res.result.total * 1;
          this.list = res.result.list;
          console.log(this.list);
          res.result.list.forEach((item, index) => {
            // console.log(item)
            if (item.bind == true) {
              this.$set(item, "status", false);
            } else if (item.bind == false) {
              this.$set(item, "status", true);
            }
          });
          setTimeout(() => {
            this.loading = false;
          }, 500);
        } else {
          this.list = [];
          this.totalDataNumber = 0;
          setTimeout(() => {
            this.loading = false;
          }, 3000);
        }
      });
    },

    //获取所有的门禁卡数据，获取了全部数据
    getALLDate() {
      let param = {
        pageNum: 0,
        pageSize: 0
      };
      this.$postJson(
        "dmc/rfidLabel/queryGroupRfidLabelListWithPage",
        param
      ).then(res => {
        console.log(res);
        this.allList = res.result.list;
        console.log(this.allList);
      });
    },

    //获取所有老人信息
    getOldmanList() {
      let param = {
        pageNo: "0",
        pageSize: "0",
        oldName: "",
        sex: ""
      };
      this.$postJson("omc/OldmanCheckIn/showAll", param).then(res => {
        console.log(res.result.list);
        this.oldmanList = res.result.list;
        var arroldNameId = [];
        var objoldNameId = {};
        res.result.list.forEach((item, index) => {
          objoldNameId = {
            oldName: item.oldName,
            oldmanId: item.oldmanId,
            oldIdCard: item.oldIdCard
          };
          arroldNameId.push(objoldNameId);
        });
        console.log(arroldNameId);
        //深拷贝两个数组去操作select菜单 老人的绑定时 ，将老人删除  解除绑定时，将老人重新添加进老人select菜单中
        this.oldmanNameIdList = Object.assign([], arroldNameId); //深拷贝记录
        this.oldmanIdNameUnshift = Object.assign([], arroldNameId); //深拷贝记录
        console.log(this.oldmanNameIdList);
        console.log(this.oldmanIdNameUnshift);
        console.log(res.result.list);
      });
    },

    //查询部门信息
    getDepartInfo() {
      let param = {};
      this.$postForm("uac/dept/getDeptVoAll", param).then(res => {
        console.log(res);
        if (res.code === 200) {
          var deptId = res.result[0].id; //获取父级部门的id,用来获取所有的员工信息
          console.log(deptId);
          this.getEmployeeList(deptId);
        }
      });
    },

    //获取所有员工信息
    getEmployeeList(deptId) {
      let param = {
        pageNum: "0",
        pageSize: "0",
        deptId: deptId
      };
      this.$postJson("uac/emp/queryUserListByEmpWithPage", param).then(res => {
        console.log(res.result.list);
        this.oldmanList = res.result.list;
        var arroldNameId = [];
        var objoldNameId = {};
        res.result.list.forEach((item, index) => {
          objoldNameId = {
            oldName: item.userName,
            oldmanId: item.userId,
            oldIdCard: item.idCard
          };
          arroldNameId.push(objoldNameId);
        });
        console.log(arroldNameId);
        //深拷贝两个数组去操作select菜单 员工的绑定时 ，将员工删除  解除绑定时，将员工重新添加进员工select菜单中
        this.oldmanNameIdListTwo = Object.assign([], arroldNameId); //拷贝记录
        this.oldmanIdNameUnshiftTwo = Object.assign([], arroldNameId); //拷贝记录
        console.log(this.oldmanNameIdListTwo);
        console.log(this.oldmanIdNameUnshiftTwo);
        console.log(res.result.list);
      });
    },

    //查询门禁卡角色列表
    queryAccessRoleList() {
      this.roleList = [];
      let params = new Object();
      params.pageNum = 0;
      params.pageSize = 0;
      console.log(params);
      this.$postJson("dmc/rfidLabelRole/queryListWithPage", params).then(
        res => {
          console.log(res);
          if (res.code == 200) {
            this.roleList = res.result.list;
          }
          console.log(this.roleList, "this.roleList");
        }
      );
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    }
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    //  tableData(newV,oldV) {
    //      console.log(newV,oldV);
    //      deep: true  //深度监听
    // },
    data: "onSubmit", //值可以为methods的方法
    oldmanNameIdList: {
      handler: function(newValue, oldValue) {
        console.log(newValue);
        this.oldmanNameIdList = newValue;
      },
      deep: true
    }
  },

  created() {
    //组件创建完后获取数据，
    //此时 data 已经被 observed 了
    this.getTableData();
    this.getOldmanList();
    this.getALLDate();
    this.getDepartInfo();
  },

  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_accesslist", () => {
      this.getTableData();
    });
    //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("handleDeletechange_accesslist", () => {
      this.getTableData();
    });
    //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormEditchange_accesslist", () => {
      this.getTableData();
    });
  },
  components: { iTable } //注册子组件
};
</script>
<style lang="scss" scoped>
.cardlist {
  .cardlist-m {
    padding: 10px 0 0 5px;
  }
  .height40 {
    height: 40px;
    line-height: 40px;
  }
  .height50 {
    height: 50px;
    line-height: 50px;
  }
}
//修改element-ui默认的样式
.del {
  color: red !important;
}
.exitrecord {
  color: green !important;
  margin-right: 10px;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .accessxz .el-dialog {
    width: 30% !important;
  }
}
//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .accessedit .el-dialog {
    width: 30% !important;
  }
}
//绑定紧急按钮位置和房间的dialog
@media screen and (min-width: 1200px) {
  ::deep .bangdilocation .el-dialog {
    width: 30% !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1199px) {
  ::deep .bangdilocation .el-dialog {
    width: 55% !important;
  }
}
</style>


